import React, { useState } from 'react';
import { X, Megaphone, ArrowRight } from 'lucide-react';

export const AnnouncementBanner = ({ isVisible, setIsVisible }) => {
  if (!isVisible) return null;

  return (
    <div ref={setIsVisible ? null : null} className="bg-gradient-to-r from-brand via-accent to-brand bg-[length:200%_100%] animate-gradient text-white relative banner-container">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5">
        <div className="flex items-center justify-center gap-2 text-sm">
          <Megaphone className="w-4 h-4 flex-shrink-0" />
          <span className="font-medium">
            New: Open Source IAM Training Program Now Available!
          </span>
          <a
            href="mailto:tech@hakxcore.io"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden sm:inline-flex items-center gap-1 font-semibold hover:underline underline-offset-2"
          >
            Learn More
            <ArrowRight className="w-3 h-3" />
          </a>
        </div>
      </div>
      <button
        onClick={() => setIsVisible(false)}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 hover:bg-white/10 rounded-full transition-colors"
        aria-label="Dismiss announcement"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default AnnouncementBanner;
